<div
  class="flex gap-4 text-sm"
  [ngClass]="class()"
  [class.flex-row]="direction() === 'horizontal'"
  [class.flex-col]="direction() === 'vertical'"
>
  @for (option of options(); track $index) { @let checked = value() ===
  option.value;
  <label
    (click)="value.set(option.value); onChange(option.value); onTouched()"
    class="flex gap-2 cursor-pointer hover:opacity-80 transition-all"
    [class.items-center]="!option.description"
    [class.items-start]="option.description"
  >
    <input
      type="radio"
      class="radio radio-primary-500 peer"
      [name]="name()"
      [checked]="checked"
    />
    <div class="flex flex-col items-start gap-1 peer-checked:text-primary-500">
      <p>{{ option.label }}</p>
      @if (option.description) {
      <p>{{ option.description }}</p>
      }
    </div>
  </label>
  }
</div>
